import { useState } from 'react';
import api from '../api';

// A diferencia de imprimir el cheque, el comprobante es un documento de
// respaldo: no cambia el estado del cheque y se puede volver a imprimir
// las veces que haga falta.
export function useComprobanteEgreso() {
  const [preparando, setPreparando] = useState(null); // { cheque, empresa, calibracion }

  async function prepararComprobante(cheque) {
    // Trae también la calibración del banco para reconstruir, como
    // constancia, el texto exacto (con relleno incluido) que quedó
    // impreso en el cheque físico.
    const [empresaRes, plantillaRes] = await Promise.all([
      api.get('/empresa/'),
      api.get(`/bancos/${cheque.banco}/plantilla/`),
    ]);
    setPreparando({ cheque, empresa: empresaRes.data, calibracion: plantillaRes.data });
  }

  function imprimir() {
    window.print();
  }

  function cancelar() {
    setPreparando(null);
  }

  return { preparando, prepararComprobante, imprimir, cancelar };
}
